import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "card-outlined p-4" }
const _hoisted_3 = { class: "text-subtitle-underline" }
const _hoisted_4 = { class: "mb-4 pl-2" }
const _hoisted_5 = {
  for: "default",
  class: "cursor-pointer"
}
const _hoisted_6 = {
  for: "well_labo",
  class: "cursor-pointer"
}
const _hoisted_7 = { class: "flex items-center pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_alert, { class: "mb-4" }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('account.change_mode.title')), 1),
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "default",
                      value: "default",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.display_mode) = $event)),
                      class: "mb-2 mr-2 cursor-pointer"
                    }, null, 512), [
                      [_vModelRadio, _ctx.display_mode]
                    ]),
                    _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('display_mode.default')), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "well_labo",
                      value: "well_labo",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.display_mode) = $event)),
                      class: "mr-2 cursor-pointer"
                    }, null, 512), [
                      [_vModelRadio, _ctx.display_mode]
                    ]),
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t('display_mode.well_labo')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_form_submit, {
                    disabled: _ctx.btnDisabled,
                    text: _ctx.t('word.change')
                  }, null, 8, ["disabled", "text"])
                ])
              ], 32)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}